export default {
    resetPasswordExpired: 'Reset Password Expired',
    textPasswordExpired: 'You’ve tried to use old reset password link that has expired. Please use the lasted reset password link or request a new link below.',
    emailAddress: 'Email address',
    enterYourEmailAddress: 'Enter your email address',
    sendEmail: 'Send Email',
    returnToLogIn: 'Return to Log in',
    emailSent: 'Email Sent',
    resetPasswordLink: 'Reset password link has been sent to',
    notThisEmail: 'Not This Email?',
    emailAddressIsRequired: 'Email address is required',
    emailAddressIsNotValid: 'Email address is not valid'
}
